import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface Document {
  title: string,
  url: string,
  snippeds: string[]
}

export interface SearchResponse {
  summary: string | SafeHtml;
  documents: Document[]
}

@Injectable({
  providedIn: 'root'
})
export class NoteSearchService {
  constructor(private http: HttpClient) {}

  /**
   * ドキュメント検索
   * @param searchTerm 検索ワード
   * @returns 返答
   */
  public searchDocument(searchTerm: string): Observable<SearchResponse> {
    const body = { message: searchTerm };

    if(environment.localDebug) {
      return this.http.post<SearchResponse>(environment.ragUrl, body);
    }

    return this.http.post<SearchResponse>(`${environment.apiUrl}/notes/search`, body);
  }
}
